export const inputValidationState = (touched, errors) => {
  if (!touched) return "form-control";
  if (touched && !errors) return "form-control is-valid";
  if (errors) return "form-control is-invalid";
  return "";
};
